<template>
    <div class="recover-password-wrap col-md-8 mx-auto border rounded px-2 py-2">
        <div class="title-wrap border-bottom mb-3">
            <h1>{{$ml.with('VueJS').get('RecoverPassword')}}</h1>
        </div>
        <div class="w-100 form-wrap">
            <b-form>
                <b-form-group id="input-email" :label="`${$ml.with('VueJS').get('Email')}:`" label-for="email" class="text-left">
                    <b-form-input
                            id="email"
                            v-model="form.username"
                            type="email"
                            placeholder=""
                    ></b-form-input>
                </b-form-group>

                <b-form-group id="input-phone" :label="`${$ml.with('VueJS').get('PhoneNumber')}:`" label-for="phone" class="text-left">
                    <b-form-input
                            id="phone"
                            v-model="form.phone"
                            type="tel"
                            placeholder=""
                    ></b-form-input>
                </b-form-group>
            </b-form>

            <b-button type="submit" variant="success" class="w-100" @click="sendRecoverCode()">{{$ml.with('VueJS').get('RecoverPassword')}}</b-button>
        </div>
    </div>
</template>

<style lang="scss">
    .profile-wrap {
        background-color: #f2f2f2;
    }
    .title-wrap h1 {
        line-height: 85px;
    }
</style>

<script>
  import axios from 'axios';
  import { apiRoot } from "@/helpers/variables";
  import mixinUtils from "@/components/mixinUtils";
  export default {
    name: 'recover-password',
    mixins: [mixinUtils],
    components: {
    },
    data: () => ({
      form: {
        username: null,
        phone: null,
      }
    }),
    methods: {
      sendRecoverCode () {
        const context = this
        if (context.form.username !== null) {
          axios.post(apiRoot + 'auth/recover-password',
            {
              username: context.form.username,
              phone: context.form.phone,
            },
            {
              useCredentails: true,
              headers: {
                'Content-Type': 'application/json'
              }
            }
          ).then(response => {
            this.$store.commit('setUser', response.data);

            this.$bvToast.toast(`${response.data.message}`, {
              title: 'Восстановление доступа',
              autoHideDelay: 5000,
              variant: 'success',
              appendToast: false,
              toaster: 'b-toaster-bottom-right',
            })
          }).catch(error => {
            switch (error.response.status) {
              default:
                this.$bvToast.toast(`${error.message}`, {
                  title: 'Ошибка',
                  autoHideDelay: 5000,
                  variant: 'danger',
                  appendToast: false,
                  toaster: 'b-toaster-bottom-right',
                })
                break;
            }

          });
        } else if (context.form.phone !== null) {
          this.$bvToast.toast(`Восстановление доступа по СМС сейчас недоступно!`, {
            title: 'Уведомление',
            autoHideDelay: 5000,
            variant: 'warning',
            appendToast: false,
            toaster: 'b-toaster-bottom-right',
          })
        }
      }
    },
    mounted() {

    }
  }
</script>